import { render } from "./loginSet.vue?vue&type=template&id=5833dbfd&scoped=true"
import script from "./loginSet.vue?vue&type=script&lang=js"
export * from "./loginSet.vue?vue&type=script&lang=js"

import "./loginSet.vue?vue&type=style&index=0&id=5833dbfd&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5833dbfd"]])

export default __exports__